import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldSignature from '../../components/FieldSignature';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step14View = ({isValid}) => {
  return (
    <Form className={styles.formContainer}>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id='step14.form.title'
          />
        </div>
      </div>
      <div className={styles.contentBlock}>
        <div className={`${styles.input} ${styles.text}`}>
          <FormattedMessage
            id={'step14.form.note.declaration.1'}
            defaultMessage={'I declare that the details I have provided here are full and correct. I am aware that omitting or submitting incorrect information is a violation of the Income Tax Ordinance'}
          />
        </div>
        <div className={`${styles.input} ${styles.text}`}>
          <FormattedMessage
            id={'step14.form.note.declaration.2'}
            defaultMessage={'I undertake to notify the self-employed person of any change that will take place in the personal details and details.'}
          />
        </div>

      </div>
      <div className={styles.innerPadding}>
        <div className={`${styles.input} ${styles.text} ${styles.bigMargin}`}>
          <FormattedMessage
            id={'common.form.note.unigender'}
            defaultMessage={'The form is worded in masculine language but is addressed to both men and women'}
          />
        </div>
        <FieldSignature
          fieldId='signature'
          label={(
            <FormattedMessage
              id='common.form.signature.label'
              defaultMessage={'Customer\'s signature'}
            />
          )}
          containerStyles={styles.input}
          disabled={true}
        />
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
          className={styles.sendBtn}
        />
        {!isValid && <ErrorValidation />}
      </div>
    </Form>
  )
};

Step14View.propTypes = {
  isValid: PropTypes.bool,
};

export default Step14View;
